import React, { useState, useEffect } from 'react';
import { Grid } from '@mui/material';
import CountWidget from './count-widget.component';
import { getCounters } from '../../services/reports.service';
import {
  CONTENT_ALIAS,
  SHOW_CONTENT_CATEGORIES,
  SHOW_CONTENT_VIDEOS,
} from '../../config/const.config';
import ROUTE_PATH from '../../config/routes.config';

const Counters = () => {
  const [counters, setCounters] = useState({
    videos: 0,
    ads: 0,
    categories: 0,
    languages: 0,
  });

  useEffect(() => {
    getCounters()
      .then((res) => {
        setCounters({
          ...counters,
          videos: res?.data?.videos || 0,
          ads: res?.data?.ads || 0,
          categories: res?.data?.categories || 0,
          languages: res?.data?.languages || 0,
        });
      })
      .catch(() => {
        // ignore
      });
  }, []);

  return (
    <Grid container spacing={1.5} alignItems="stretch">
      {SHOW_CONTENT_CATEGORIES && (
        <Grid item xs={12} sm={6} md={3} sx={{ display: 'flex' }}>
          <CountWidget
            title={`${CONTENT_ALIAS.CATEGORY_PLURAL}`}
            total={counters.categories}
            color="info"
            icon="material-symbols:category-outline-rounded"
          />
        </Grid>
      )}

      {SHOW_CONTENT_VIDEOS && (
        <>
          <Grid item xs={12} sm={6} md={3} sx={{ display: 'flex' }}>
            <CountWidget
              title={`${CONTENT_ALIAS.VIDEO_PLURAL}`}
              total={counters.videos}
              color="success"
              icon="octicon:video-16"
              navLink={ROUTE_PATH.CONTENT_VIDEOS}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3} sx={{ display: 'flex' }}>
            <CountWidget
              title="Ads"
              total={counters.ads}
              color="warning"
              icon="mdi:advertisements"
              navLink={ROUTE_PATH.CONTENT_ADS}
            />
          </Grid>
        </>
      )}

      <Grid item xs={12} sm={6} md={3} sx={{ display: 'flex' }}>
        <CountWidget
          title="Languages"
          total={counters.languages}
          color="error"
          icon="mdi:language"
          navLink={ROUTE_PATH.CONTENT_LANGUAGES}
        />
      </Grid>
    </Grid>
  );
};

export default Counters;
